import { render, staticRenderFns } from "./BBLazyBackground.vue?vue&type=template&id=6a294980&"
import script from "./BBLazyBackground.vue?vue&type=script&lang=ts&"
export * from "./BBLazyBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports